import axios from "axios";
import {config} from "../constants";
import authHeader from "./auth-header";
import CommonService from "./common.service";

class CustomerService {

    search(customerRiskLevel, dateType, startDate, endDate, filterCriteria) {
        return axios.post(
            config.API_URL + "customer/search",
            {
                customerRiskLevel: customerRiskLevel,
                dateType: dateType,
                startDate: startDate,
                endDate: endDate,
                filterCriteria: filterCriteria,
                lang: CommonService.getLang()
            },
            {headers: authHeader()}
        );
    }

    getCustomers() {
        return axios.get(
            config.API_URL + "customer/all-by-company",
            {headers: authHeader()}
        );
    }

    getUsersByCompany() {
        return axios.get(
            config.AUTH_URL + "user/company",
            {headers: authHeader()}
        );
    }

    sendInvitation(data) {
        return axios.post(
            config.AUTH_URL + "user/send-invitation", data,
            {headers: authHeader()}
        );
    }

    profile(customerNo) {
        return axios.post(
            config.API_URL + "customer/profile",
            {
                customerNo: customerNo,
                lang: CommonService.getLang()
            },
            {headers: authHeader()}
        );
    }

    riskLevels() {
        return axios.get(config.API_URL + "customer/risk-levels", {headers: authHeader()});
    }

    getCustomerNoFromTx() {
        const customerNoFromTx = localStorage.getItem("customerNoFromTx");
        // localStorage.removeItem("customerNoFromTx");
        return customerNoFromTx;
    }

    saveCustomerNoFromTx(customerNoFromTx) {
        localStorage.setItem("customerNoFromTx", customerNoFromTx)
    }

    removeCustomerNoFromTx() {
        localStorage.removeItem("customerNoFromTx")
    }

}

export default new CustomerService();
